// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__2Wpi5","addNewRowTable":"styles_addNewRowTable__3MrEd"};